import { TextColumn } from './TextColumn';
import { formatLocalTime } from '../../utils/Date';
import { Period, periodToDateFormatMap } from '../../interfaces/Period';

type DateColumnProps = {
  value?: Date;
  period?: Period;
};

export const DateColumn = (props: DateColumnProps) => (
  <TextColumn
    value={
      props.value
        ? formatLocalTime(
            props.value,
            props.period ? periodToDateFormatMap[props.period] : undefined,
          )
        : ''
    }
  />
);
